window.addEventListener("load", function() {
  function onSwymLoadCallback(swat) {
    let event = 'sw:addedtocart';

    let addedToCart = async function(e) {
      var data = e.detail.d.productData;
      const cartDrawer = document.querySelector('cart-drawer');
      const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
      const cartSections = await fetch(window.Shopify.routes.root + `?sections=${cartDrawer.dataset.sectionId}`).then(res => res.json());
      cartJson['sections'] = cartSections;

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: {
            product: data,
          },
        })
      );
      cartDrawer.show();

      const trackingItemData = {
        item_name: data.name,
        item_id: data.sku,
        coupon: '',
        discount: '',
        item_category: data.cartLineItem?.product_type || '',
        item_list_id: '',
        item_list_name: '',
        quantity: 1,
        price: data.price
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: 'USD',
          value: data.price,
          items: [
            {
              ...trackingItemData
            },
          ]
        }
      });
    };
      window._swat.evtLayer.addEventListener(event, addedToCart);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});